import { Component, inject } from '@angular/core';
import {TranslationService} from '../../../core/services/translation.service';

@Component({
  selector: 'app-complaint-without-login-after',
  templateUrl: './complaint-without-login-after.component.html',
  imports: [],
  standalone: true,
  styleUrls: ['./complaint-without-login-after.component.css']
})
export class ComplaintWithoutLoginAfterComponent {  translationService = inject(TranslationService);

}
